import { useEffect, useState } from "react";
import {
  DashboardRange,
  RANGE_OPTIONS,
  TmLeaderboardRow,
  getTmLeaderboard,
} from "features/dashboard/api/DashboardApi";
import { formatLastActivity } from "features/dashboard/ui/shared";

export default function TmLeaderboard() {
  const [range, setRange] = useState<DashboardRange>("today");
  const [rows, setRows] = useState<TmLeaderboardRow[] | null>(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setError("");
    getTmLeaderboard(range)
      .then(setRows)
      .catch((e) => setError(e.response?.data?.detail || "Failed to load Technical Manager activity"))
      .finally(() => setLoading(false));
  }, [range]);

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-base font-bold text-foreground font-inter">Technical Manager Activity</h2>
        <select
          value={range}
          onChange={(e) => setRange(e.target.value as DashboardRange)}
          className="bg-surface-muted border border-border rounded-full px-3.5 py-1.5 text-xs text-foreground font-inter cursor-pointer hover:border-muted-foreground focus:outline-none focus:border-primary transition-colors"
        >
          {RANGE_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>

      <div className="rounded-2xl border border-border bg-surface overflow-hidden">
        {error ? (
          <p className="px-4 py-6 text-sm text-destructive font-inter">{error}</p>
        ) : (
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-border text-left">
                <th className="px-4 py-2.5 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground font-inter">Technical Manager</th>
                <th className="px-4 py-2.5 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground font-inter">Applied</th>
                <th className="px-4 py-2.5 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground font-inter">Archived</th>
                <th className="px-4 py-2.5 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground font-inter">Tracked</th>
                <th className="px-4 py-2.5 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground font-inter">Last Activity</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={5} className="px-4 py-6 text-center text-sm text-muted-foreground font-inter">
                    Loading…
                  </td>
                </tr>
              ) : !rows || rows.length === 0 ? (
                <tr>
                  <td colSpan={5} className="px-4 py-6 text-center text-sm text-muted-foreground font-inter">
                    No Technical Managers found.
                  </td>
                </tr>
              ) : (
                rows.map((tm) => (
                  <tr key={tm.employee_id} className="border-b border-border last:border-b-0">
                    <td className="px-4 py-2.5 text-foreground font-semibold font-inter">
                      {tm.name} <span className="text-muted-foreground text-xs font-normal">({tm.employee_code})</span>
                    </td>
                    <td className="px-4 py-2.5 text-foreground font-inter">{tm.applied}</td>
                    <td className="px-4 py-2.5 text-foreground font-inter">{tm.archived}</td>
                    <td className="px-4 py-2.5 text-foreground font-inter">{tm.tracked}</td>
                    <td className="px-4 py-2.5 text-muted-foreground font-inter text-xs">{formatLastActivity(tm.last_activity_at)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
